<template>
  <div class="modal light" :class="{ 'is-active': isActive }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t('modals.condition.title') }}</p>
        <button class="delete" aria-label="close" @click="closeModal"></button>
      </header>
      <section class="modal-card-body">
        <div
          v-for="(cond, index) in conditions"
          v-html="cond"
          v-bind:key="index"
          class="m-b-20"
        ></div>
        <div class="box-button m-t-30">
          <div class="full-50"></div>
          <button class="button full-50 is-primary" @click="closeModal">
            {{ $t('modals.confirmBtn') }}
          </button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import apiLookup from '@/api/lookup'

export default {
  name: 'ModalCondition',
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      conditions: []
    }
  },
  mounted() {
    this.lookupConditions()
  },
  methods: {
    async lookupConditions() {
      let loading = this.$loading.show()

      setTimeout(async () => {
        try {
          const data = await apiLookup.lookupConditions()
          this.conditions = data.conditions

          loading.hide()
        } catch {
          loading.hide()
        }
      }, 200)
    },
    closeModal() {
      this.$emit('closeModal', null)
    }
  }
}
</script>
